module.exports = __webpack_public_path__ + "img/360-limrum.da4c0cb3.jpg";